export type YoutubeShape = { youtubeId: string; content: string };

export const componentMapKeys = ['GradeLevel', 'TextArea', 'Select', 'Transcript', 'Text', 'TextAreaWithUpload', 'TextInput'] as const;
export type ComponentKey = (typeof componentMapKeys)[number];
